module.exports = __webpack_public_path__ + "static/img/VE.bad5f73b.svg";